import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { RaiseService } from '../../../core/services/api/raise.service';
import { ErrorService } from '../../../core/services/error.service';
import { PopupService } from '../../../shared/services/popup/popup.service';

@Component({
    selector: 'app-submitted-application-modal',
    templateUrl: './submitted-application-modal.component.html',
    standalone: false
})
export class SubmittedApplicationModalComponent {
    @Input() submission: any;
    @Input() submissionToken: string | null = null;
    @Input() viewToken: string | null = null;

    constructor(
        public activeModal: NgbActiveModal,
        private router: Router,
        private raiseService: RaiseService,
        private errorService: ErrorService,
        private popupService: PopupService
    ) { }

    private openPreRegistration(extraState: { viewOnly?: boolean; overrideExisting?: boolean }) {
        if (!this.submission?.id || !this.submission?.email || !this.viewToken) {
            this.popupService.alert('common.unknownError');
            return;
        }

        this.raiseService
            .getUnregisteredSubmissionById(
                this.submission.id,
                this.submission.email,
                this.viewToken
            )
            .subscribe({
                next: (detail) => {
                    this.activeModal.close();

                    this.router.navigate(['/raise/pre-registration'], {
                        state: {
                            prefillData: detail,
                            submissionToken: this.submissionToken,
                            viewToken: this.viewToken,
                            originalTemplateId: detail?.dynamicFormTemplateId ?? detail?.DynamicFormTemplateId ?? null,
                            ...extraState
                        }
                    });
                },
                error: (err) => {
                    this.errorService.showError(err);
                }
            });
    }

    viewMyApplication() {
        this.openPreRegistration({ viewOnly: true });
    }

    submitNewApplicationOverride() {
        this.openPreRegistration({ overrideExisting: true });
    }
}
